/**
 * lib/consent.ts
 *
 * What a parent's consent act sends to parent-api (TUP-1835). Redeeming a
 * child's code and approving a child's request both consent AND link in one
 * step, so both carry the same body. The versions name the consent text and
 * the data scope the parent saw; the API refuses any other version and stores
 * its own copy of that text in the language and place (app or web) sent here.
 */

import { Capacitor } from '@capacitor/core';
import { PARENT_CONSENT_VERSION, PARENT_DATA_SCOPE_VERSION } from '@tupai/i18n/parent';
import { getLanguage } from '@/lib/language';

export function consentPayload() {
  return {
    consent_acknowledged: true as const,
    consent_version: PARENT_CONSENT_VERSION,
    data_scope_version: PARENT_DATA_SCOPE_VERSION,
    language: getLanguage(),
    surface: Capacitor.isNativePlatform() ? ('app' as const) : ('web' as const),
  };
}
